export type { NoTranslateProps } from './NoTranslateWrapper.type';
export { NoTranslateWrapper } from './NoTranslateWrapper';
